export default function getLocale() {
  return window.TMF_CONFIG?.locale ?? 'en';
}
